import { Template } from "./template.js"
import { Left_menu } from './left_menu/component.js'
import { Notifications } from './notifications/component.js'

const Page5_notifications = {
    name: 'Page5_notifications',
    components:{
        'left-menu': Left_menu,
        'notifications': Notifications
    },
    template: Template,
    data: function(){
        return{
            modems:[]
        }
    },

    created() {
		var cont = this;
		this.getModems();
	},

    methods:{
        getModems() {
			var cont = this;
			//запускаем аякс из плагина
			this.$API('static_data', 'modems', {},
				function(data) {
					cont.modems = data;
				},
				function(errorText) { console.log(errorText) });

		}
    }
}
export { Page5_notifications }


// WEBPACK FOOTER //
// ./src/app/js/components/page5_notifications/component.js